export const NOMINATION_EMPL_FIELDS = {
	bin: 'bin',
	categoryCode: 'categoryCode',
	email: 'email',
	katoAB: 'katoAB',
	mobilePhone: 'mobilePhone',
	nominationCode: 'nominationCode',
	orgName: 'orgName',
	workPhone: 'workPhone',
	okedCode: 'okedCode',
	directorFullName: 'directorFullName',
	foundationDate: 'foundationDate',
}

export const NOMINATION_STATUSES = {
	Signed: 'Signed',
	Computed: 'Computed',
	Approved: 'Approved',
	Completed: 'Completed',
	Rejected: 'Rejected',
}

export const NOMINATION_STATUSES_LABEL = {
	[NOMINATION_STATUSES.Signed]: 'nomination.status.signed',
	[NOMINATION_STATUSES.Computed]: 'nomination.status.сomputed',
	[NOMINATION_STATUSES.Approved]: 'nomination.status.approved',
	[NOMINATION_STATUSES.Completed]: 'nomination.status.completed',
	[NOMINATION_STATUSES.Rejected]: 'nomination.status.rejected',
}

export const NOMINATION_DTSP_FIELDS = {
	byCategory: 'byCategory',
	largeCategoryPlaces: 'largeCategoryPlaces',
	orgBin: 'orgBin',
	place: 'place',
	nominationCode: 'nominationCode',
	smallCategoryPlaces: 'smallCategoryPlaces',
	year: 'year',
}